<template>
  <div class="modal" v-if="modal?.active || false" style="
      position: absolute;
      width: 100%;
      height: 100%;
      background: #00000090;
      top: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    ">
    <div class="modal-content" style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: white;
        padding: 1.5em;
        border-radius: 0.2em;
        width: 75%;
        position: relative;
      ">
      <button v-if="modal?.type !== 'loader'" class="modal-content_close-button" style="
          position: absolute;
          top: 0.5em;
          right: 0.5em;
          border: none;
          background: none;
          font-size: 1.5em;
          cursor: pointer;" @click="cancel">
        <i class="material-icons">close</i>
      </button>
      <div class="moda-content_icon">
        <div v-if="modal?.type === 'success'">
          <i class="material-icons" style="color: #0f0; font-size: 55px">
            check_circle
          </i>
        </div>
        <div v-if="modal?.type === 'warning'">
          <i class="material-icons" style="color: #ff8f00; font-size: 52px">
            warning
          </i>
        </div>
        <div v-else-if="modal?.type === 'error'">
          <i class="material-icons" style="color: #f00; font-size: 52px">
            error
          </i>
        </div>
        <div v-else-if="modal?.type === 'info'">
          <i class="material-icons" style="color: #007bff; font-size: 52px">
            info
          </i>
        </div>
        <div v-else-if="modal?.type === 'loader'">
          <div class="loader-center">
            <div class="loader"></div>
          </div>
        </div>
      </div>
      <div v-if="modal?.title" class="modal-content_message" style="font-size: 1em; margin: 1.5em 0.25em; text-align: center">
        {{ 
            this.$i18n.t(modal?.title)
        }}
      </div>
      <div v-if="modal?.body" class="modal-content_message" style="font-size: 1em; margin: 1.5em 0.25em; text-align: center">
        {{ 
            this.$i18n.t(modal?.body)
        }}
      </div>
      <div class="modal-actions">
        <button v-if="modal?.type !== 'loader'" class="modal-actions_button" style="
            padding: 0.5em 1em;
            border: none;
            background: #007bff;
            color: white;
            font-size: 1em;
            cursor: pointer;
            border-radius: 0.2em; " @click="confirm">
          {{ this.$i18n.t("modal.actions.ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "global_modal",
  computed: {
    modal() {
      return this.$store.state.modal;
    },
  },
  methods: {
    confirm() {
      this.modal.resolve(true);
      this.$store.commit("SET_MODAL_DEACTIVATE");
    },
    cancel() {
      this.modal.resolve(false);
      this.$store.commit("SET_MODAL_DEACTIVATE");
    },
  },
};
</script>
